import axios from "../../utils/axios";
import {HIDE_REQUESTED_NOTIFICATION, REMOVE_NOTIFICATION, SET_NOTIFICATIONS} from "./actionTypes";
import {toast} from 'react-toastify';

export const getNotifications = role => dispatch => {
  let endpoint = '';
  switch (role) {
    case 'company':
      endpoint = 'company-admin-notification/';
      break;
    case 'warehouse':
      endpoint = 'get-warehouse-admin-notifications/';
      break;
    case 'general':
      endpoint = 'company-user-notification/';
      break;
    default:
      break;
  }

  axios
      .get(`${endpoint}?show_all`)
      .then(response => {
        const data = {};

        switch (role) {
          case 'company':
            data.notifications = response.data.results;
            data.requestToChange = [];
            break;
          case 'warehouse':
            data.notifications = response.data.result.notifications;
            data.requestToChange = response.data.result.request_to_change;
            break;
          case 'general':
            data.notifications = response.data.results;
            data.requestToChange = [];
            break;
          default:
            break;
        }

        dispatch(setNotifications(data))
      })
      .catch(console.log);
};

const setNotifications = data => ({
  type: SET_NOTIFICATIONS,
  payload: data
});

export const markAsSeen = (id, role) => dispatch => {
  let endpoint = '';

  switch (role) {
    case 'company':
      endpoint = `company-admin-notification/${id}/`;
      break;
    case 'warehouse':
      endpoint = `warehouse-admin-notification/${id}/`;
      break;
    case 'general':
      endpoint = `company-user-notification/${id}/`;
      break;
    default:
      break;
  }

  axios
      .patch(endpoint, {seen: true})
      .then(response => dispatch(removeNotification(response.data.id)))
      .catch(console.log);
};

const removeNotification = id => ({
  type: REMOVE_NOTIFICATION,
  payload: id
});

export const acceptOrReject = (id, accepted = true) => dispatch => {
  axios
      .patch(`update-booked-dock-change/${id}/`, {accepted})
      .then(response => {
        dispatch(hiderequestedNotification(response.data.id));
        if (response.data.accepted) {
          toast.success('Accepted.', {
            position: toast.POSITION.TOP_RIGHT,
            className: ''
          });
        } else {
          toast.error('Rejected.', {
            position: toast.POSITION.TOP_RIGHT,
            className: ''
          });
        }
      })
      .catch(console.log);
};

const hiderequestedNotification = id => ({
  type: HIDE_REQUESTED_NOTIFICATION,
  payload: id
});


// WEBPACK FOOTER //
// ./src/store/actions/notification.js